import { HiddenDataWrapper } from "helpers/hiddenData";
import { paths } from "helpers/paths";
import React from "react";
import { Link } from "react-router-dom";

const Contract = ({ contract, counterparty, roles }) => {
    if (!contract || !counterparty) {
        return null;
    }
    return (
        <>
            <div className="show-bid__main-info--title">Договор с контрагентом</div>
            <div className="show-bid__main-info--value" data-test-id="contract">
                <HiddenDataWrapper hidden={roles.isTruckingOrganizationDispatcher}>
                    <Link to={paths.counterpartyContractsShow(counterparty.id, contract.id)}>{contract.number}</Link>
                </HiddenDataWrapper>
            </div>
        </>
    );
};

export default Contract;
